import SingleAssetEditor from './SingleAssetEditor'

export default SingleAssetEditor
